import React from "react";
import "./Testimonial.scss";
import ServiceData from "../../ServiceData";
import { Nav } from "react-bootstrap";
import { Avatar, Box, Flex } from "@chakra-ui/react";

const Testimonial = () => (
  <>
    <Flex
      direction="row"
      align="center"
      marginTop="50px"
      marginBottom={{ base: "10px", md: "40px", lg: "70px" }}
      wrap={{ base: "wrap", md: "wrap", lg: "nowrap" }}
    >
      <Box width={{ base: "100%", md: "60%", lg: "40%" }}>
        <img className="sch-classs" src="/images/school.png" alt="school" />
      </Box>
      <Box
        marginLeft={{ base: "0px", md: "0", lg: "20px" }}
        width={{ base: "100%", md: "80%", lg: "60%" }}
        paddingLeft={{ base: "10px", md: "10px", lg: "0" }}
      >
        <div className="school-content">
          <h3 className="school-mag">School Management</h3>
          <p className="sch-mag-para">
            It also comes with innovative school management features (which can
            be used along with the learning management system) by schools (K-12
            ,colleges and other higher institutions to
          </p>
          <span>Provide high quality online-based educational services.</span>
        </div>
      </Box>
    </Flex>
    <div className="elipse" />
    <div className="testi">
      <h3 className="what-users">What our users said about us</h3>
      <p>It also comes with innovative school management</p>
      <div className="testi-cards">
        {ServiceData.map((card) => {
          return (
            <div className="cards" key={card.id} card={card}>
              <div className="title">
                <Avatar src={card.img} alt={card.name} />
                <h5 className="title1">
                  {card.name}
                  <br />
                  <span>{card.title}</span>
                </h5>
              </div>
              <h5 className="title-para">`{card.para}`</h5>
            </div>
          );
        })}
      </div>
    </div>
    <div className="earn">
      <img className="earning" src="/images/earn.png" alt="earn-pix" />
      <div className="earn-cont">
        <h3 className="earn-head">
          Earn money on the side as a Content Provider
        </h3>
        <p>
          You’ve spent a long time building expertise in something that many,
          many, many people would love to learn about.
        </p>
        <p>
          Why not teach others what you know by creating and selling an online
          course? Plan, create and price your course and youre good to go!
        </p>
        <Nav.Link className="getStarted">Get Started</Nav.Link>
      </div>
    </div>
  </>
);

export default Testimonial;
